import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';

/* eslint-disable no-unused-vars */
enum ActionType {
  OPERATION_RECORD = 'OPERATION_RECORD',
  CLEAN_OPERATION_LIST = 'CLEAN_OPERATION_LIST',
}

// export const actionFetchOprationLog = createAction(
//   eventProvider.makeResponseType(ActionType.OPERATION_RECORD)
// );

export const actionClearOperationList = createAction(
  eventProvider.makeResponseType(ActionType.CLEAN_OPERATION_LIST),
);

export default ActionType;
